/**
 * IntelliGems A/B Test: Mobile Inline Search
 *
 * Control (A): default theme search modal
 * Variant (B): inline search bar visible on mobile load, no close icon
 */
(function () {
  'use strict';

  var MOBILE_SEARCH_MQ = window.matchMedia('(max-width: 640px)');
  var variantBActive = false;
  var searchObserver = null;
  var listenersAttached = false;
  var isApplying = false;
  var applyTimer = null;

  function isMobileSearchView() {
    return MOBILE_SEARCH_MQ.matches;
  }

  function isIntelliGemsVariantB() {
    var body = document.body;
    var html = document.documentElement;

    if (!body || !html) return false;

    var testActive = body.getAttribute('data-gem-test-active') ||
      html.getAttribute('data-gem-test-active') ||
      body.getAttribute('data-gem-variant') ||
      html.getAttribute('data-gem-variant');

    return testActive === 'variant';
  }

  function stripMobileSearchOverlay() {
    document.documentElement.classList.remove('no-scroll');
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.remove('is-visible');
    var headerSection = document.getElementById('shopify-section-header');
    if (headerSection) headerSection.style.zIndex = '';
  }

  function openVariantBSearch() {
    var search = document.getElementById('Search');
    if (!search) return;

    if (!document.documentElement.classList.contains('mobile-inline-search-b')) {
      document.documentElement.classList.add('mobile-inline-search-b');
    }

    if (search.getAttribute('aria-hidden') !== 'false') {
      search.setAttribute('aria-hidden', 'false');
    }

    stripMobileSearchOverlay();
    variantBActive = true;
  }

  function closeVariantBSearch() {
    document.documentElement.classList.remove('mobile-inline-search-b');
    variantBActive = false;

    if (!isMobileSearchView()) return;

    var search = document.getElementById('Search');
    if (search && !isIntelliGemsVariantB()) {
      search.setAttribute('aria-hidden', 'true');
      stripMobileSearchOverlay();
    }
  }

  function watchSearchState() {
    var search = document.getElementById('Search');
    if (!search || searchObserver) return;

    searchObserver = new MutationObserver(function () {
      if (!variantBActive || !isMobileSearchView()) return;

      if (search.getAttribute('aria-hidden') === 'true') {
        search.setAttribute('aria-hidden', 'false');
        stripMobileSearchOverlay();
      }
    });

    searchObserver.observe(search, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  function onCloseSearchClick(event) {
    if (!variantBActive || !event.target || !event.target.closest) return;

    if (event.target.closest('[data-action="close-search"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function onToggleSearchClick(event) {
    if (!variantBActive || !event.target || !event.target.closest) return;

    var trigger = event.target.closest('[data-action="toggle-search"], [data-action="open-search"]');
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openVariantBSearch();

    var input = document.querySelector('#Search [name="q"]');
    if (input) input.focus();
  }

  function attachListeners() {
    if (listenersAttached) return;

    document.addEventListener('click', onCloseSearchClick, true);
    document.addEventListener('click', onToggleSearchClick, true);

    if (typeof MOBILE_SEARCH_MQ.addEventListener === 'function') {
      MOBILE_SEARCH_MQ.addEventListener('change', scheduleApplyVariant);
    } else if (typeof MOBILE_SEARCH_MQ.addListener === 'function') {
      MOBILE_SEARCH_MQ.addListener(scheduleApplyVariant);
    }

    listenersAttached = true;
  }

  function applyVariantNow() {
    if (isApplying) return;
    isApplying = true;

    try {
      if (!document.getElementById('Search')) return;

      if (!isMobileSearchView() || !isIntelliGemsVariantB()) {
        closeVariantBSearch();
        return;
      }

      attachListeners();
      openVariantBSearch();
      watchSearchState();
    } finally {
      isApplying = false;
    }
  }

  function scheduleApplyVariant() {
    if (applyTimer) window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(applyVariantNow, 50);
  }

  function watchIntelliGemsAttributes() {
    if (!document.body) return;

    var observer = new MutationObserver(function () {
      scheduleApplyVariant();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-gem-test-active', 'data-gem-variant']
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-gem-test-active', 'data-gem-variant']
    });
  }

  function setup() {
    if (!document.body) return;

    applyVariantNow();
    watchIntelliGemsAttributes();
    window.setTimeout(applyVariantNow, 500);
    window.setTimeout(applyVariantNow, 1500);
  }

  document.addEventListener('gem:variant:changed', scheduleApplyVariant);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  window.addEventListener('load', scheduleApplyVariant);
})();
